import React from 'react';
import PropTypes from 'prop-types';
import MobilePlayer from '../../../../../components/players/mobile-player';
import { useMobileOverlay } from '../../../../../mobile-overlay/MobileOverlayProvider';

export function Playback({
  videoItem,
  channelData,
  onEnded,
  width,
  height,
  onMemberSignUp,
}) {
  const { isMobileOverlayOpen } = useMobileOverlay();

  if (isMobileOverlayOpen) {
    return null;
  }

  return (
    <MobilePlayer
      videoItem={videoItem}
      channelData={channelData}
      onEnded={onEnded}
      width={width}
      height={height}
      onMemberSignUp={onMemberSignUp}
      preload="none"
      showInitialOverlay={false}
      showPoster={false}
    />
  );
}

Playback.propTypes = {
  videoItem: PropTypes.object.isRequired,
  channelData: PropTypes.object.isRequired,
  onEnded: PropTypes.func,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  onMemberSignUp: PropTypes.func.isRequired,
};
